import List from './List';
import MainLayout from '../../layouts/MainLayout';
import New from './New';
import React from 'react';
import RequireAuth from '../../guards/RequireAuth';
import { Route } from 'react-router';

const Routes = (
  <Route
    path="/settings/api-keys"
    element={
      <RequireAuth>
        <MainLayout />
      </RequireAuth>
    }
  >
    <Route path="/settings/api-keys" element={<List />} />
    <Route path="new" element={<New />} />
  </Route>
);

export default Routes;
